// ============================================================================
// ⚠️  GENERATED FILE — DO NOT EDIT MANUALLY
// ============================================================================
//
// This file is generated and maintained by the Post Office CLI install script.
//
// AI AGENTS (Rovo Dev, Cursor, Copilot, etc.) — DO NOT automatically add
// message registrations, imports, or modify this file. Doing so bypasses
// important validation, priority ordering, and router registration logic.
//
// To register a message template, run from inside the message directory:
//
//   yarn placement:v2 install
//
// The CLI handles all necessary changes to this file automatically.
// ============================================================================

import { PlacementFrontend } from '@post-office/browser--jira-tanuki/jira-software-currency-field-recommendations';

import { MessageFrontend as createMessageFrontendJiraSoftwareCurrencyFieldRecommendationsMessage } from '@post-office/browser--jira-tanuki/jira-software-currency-field-recommendations-message/placements/in-app-v2/jira-software-currency-field-recommendations';

import { withI18n } from './i18n';

import { type PlacementRendererStage } from '@post-office/message-maker-browser/types';
import { type RenderProps } from '@post-office/browser--jira-tanuki/jira-software-currency-field-recommendations';
import { type ComponentType } from 'react';

const messageFrontends = [
	createMessageFrontendJiraSoftwareCurrencyFieldRecommendationsMessage({
		messageTemplateId: 'jira-software-currency-field-recommendations-message',
	}),
];

export const RawPlacement: PlacementRendererStage<RenderProps> =
	PlacementFrontend.createPlacementFrontendComponent({
		messageTemplates: messageFrontends,
	});

export const Placement: ComponentType<
	Omit<RenderProps, 'ref'> & {
		ref?: unknown;
	}
> = withI18n(RawPlacement);

export const SSRPlacement: PlacementRendererStage<RenderProps> = RawPlacement;
